<template>
    <div style="margin-bottom: 140px">
        <div style="margin-bottom: 14px;text-align: left">
      <div class="page-title">
       Угода користувача
      </div>
      <div style="
    margin-top: 34px;
    font-size: 0.9rem;
">

<p>
  Редакція від 10 лютого 2025 року
  Публічний договір (оферта) на використання послуг веб-сайту pizza.black
</p>

<p>
  <b>Терміни</b>
</p>
<p>
Договір — публічний договір на використання послуг Сайту<br>
Сайт — інтернет сайт з доменним ім’ям pizza.black<br>
Продавець — ФОП Савчук Роман Володимирович. Продаж здійснюється зі складу Продавця. Реквізити та контакти знаходяться в кінці Договору<br>
Покупець — фізична особа, відвідувач Сайту, що здійснила Замовлення Товару для особистих потреб<br>
Замовлення — належним чином оформлений запит Покупця на придбання та доставку Товару<br>
Товар — споживчі товари, готові страви та напої, що пропонуються до продажу на Сайті<br>
</p>
 

<p>
  <b>1. Загальні положення</b>
</p>
<p>
1.1. Прийняття умов Договору є рівносильним договору, підписаного між Продавцем і Покупцем. Здійснюючи замовлення Товару Покупець приймає правила і умови користування Сайтом, зазначені в Договорі. Якщо Покупець не згоден з правилами та умовами він зобов’язаний припинити використання Сайту.<br>
1.2. До відносин між Покупцем і Продавцем застосовуються положення законодавства України. Представлені на сайті Товари та Договір є публічною офертою, відповідно до статей 633 і 634 Цивільного Кодексу України.<br>
1.3. Продавець має право вносити зміни до Договору в односторонньому порядку, шляхом розміщення нової редакції Договору на Сайті без додаткового повідомлення Покупця. Нова редакція вступає в силу з дати публікації на Сайті, якщо інше не буде зазначено в Договорі.<br>
1.4. Продавець має право на переуступку (або інший способі передачі своїх прав та обов’язків) третім особам.<br>
1.5. Сайт може тимчасово, частково або повністю бути недоступним внаслідок проведення робіт або з будь-яких інших причин технічного характеру без попередження Покупця.<br>
1.6. Якщо окремі положення або пункти Договору будуть визнані недійсними або незаконними, то таке положення може бути виключено з Договору, і замінено новим положенням. Причому така заміна не призводить до перегляду Договору або визнання всього Договору недійсним.<br>
</p>
 

<p>
  <b>2. Товар</b>
</p>
<p>
2.1. На Сайті пропонуються до продажу товари, в тому числі, але не виключно споживчі товари, готові страви та напої. У разі відсутності Товарів, Продавець має право виключити такий Товар із Замовлення та повідомити про це Покупця через електронну адресу або за телефоном, зазначеними Покупцем.<br>
2.2. На Сайті зазначається основна інформація про товари та фотографії. Фотографії є ілюстраціями до Товару та можуть відрізнятися від фактичного зовнішнього вигляду Товару. Інформація (опис) щодо Товару може містити друкарські помилки, Продавець може надати додаткову наявну інформацію про товар за запитом Покупця.<br>
2.3. Продавець може в односторонньому порядку змінити ціну Товару, зазначену на сайті. Право не поширюється на замовлений та вже оплачений, згідно умов Договору, Товар.<br>
</p>
 

<p>
  <b>3. Замовлення Товару</b>
</p>
<p>
3.1. Покупець може оформити запит на придбання та доставку Товару, який є в наявності і представлений на Сайті. Оформлення здійснюється за допомогою зазначенням номеру телефону, на який представник Продавця здійснює дзвінок та приймає замовлення та через замовлення в електронному вигляді.<br>
3.2. Оформлення замовлення в електронному вигляді здійснюється через «Кошик» на Сайті. Покупець, отримавши інформацію про товар на Сайті на свій розсуд вибирає Товар, натискає кнопку «Замовити». У «Кошику» Покупець самостійно перевіряє правильність вибору Товару, заповнює інформацію про себе, адресу доставки, спосіб доставки та спосіб оплати , і оформляє замовлення натискаючи кнопку «Замовити».<br>
3.3. Покупець самостійно несе повну відповідальність за надання помилкових або неправдивих відомостей, що спричинило неможливість належного виконання Продавцем своїх зобов’язань перед Покупцем.<br>
3.4. У разі зміни ціни на Товар Продавець зв’язується з Покупцем через зазначені ним контакти для підтвердження замовлення або його анулювання. У разі неможливості зв’язатися з Покупцем замовлення може вважатися анульованим.<br>
3.5. Замовлення може бути анульовано Покупцем до моменту оплати і фактичної передачі Товару в разі неотримання товару Покупцем та відсутності оплати Товару в узгоджений термін.<br>
</p>


<p>
  <b>4. Оплата Товару</b>
</p>
<p>
4.1. Ціна Товару зазначена в гривнях на умовах EXW (ІНКОТЕРМС 2010).
4.2. Ціна товару не включає в себе комісію і додаткові збори банків та платіжних систем. Покупець самостійно і за свій рахунок сплачує такі збори. Розмір комісії або додаткового збору повідомляє відповідний банк та платіжна система.<br>
4.3. Ціна Товару може бути змінена Продавцем в односторонньому порядку на умовах, зазначених в Договорі.<br>
4.4. Покупець може сплатити за Товар онлайн або в момент отримання товару кур’єром. Вибір оплати здійснюється при оформлені Замовлення Товару.<br>
4.5. Якщо в Замовлені є алкогольні Товари, зазначені на Сайті, то Покупець може сплатити за все Замовлення виключно готівкою кур’єру в момент отримання товару.<br>
4.6. При сплаті за Товар онлайн Покупець перенаправляється на платіжний сервіс LiqPay, де Покупець має змогу сплатити за Замовлення за допомогою карток платіжних систем Visa та Mastercard.<br>
4.7. Продавець має право надавати знижки на Товари. Умови знижок зазначаються Продавцем та можуть бути змінені Продавцем в односторонньому порядку.<br>
</p>
 

<p>
  <b>5. Доставка Товару</b>
</p>
<p>
5.1. Доставка Товару здійснюється шляхом доставки кур’єром по м. Луцьку та/або його найближчі околиці.<br>
5.2. При прийомі Товару Покупець здійснює огляд на відповідність асортименту, комплектності та якості та наявності дефектів на упаковці. У разі невідповідності Покупець може відмовитися від Товару.<br>
5.3. Моментом переходу права власності на Товар вважається момент передачі Товару Покупцю, або особі, зазначеної в Замовленні в якості отримувача. В момент переходу права власності Продавець вважається таким, що виконав свої обов’язки за Договором.<br>
5.4. Доставка Товару — окрема послуга, яка не є невід’ємною частиною Товару.<br>
5.6. Для певних районів встановлена мінімальна сума (вартість) замовлення для здійснення доставки – її можна дізнатись обравивши необхідний населений пункт та вулицю. <br>
5.7. Продавець має право відмовити покупцю у здійсненні доставки з технічних причин чи невідповідності мінімальної вартості замовлення.<br>
</p>
 

<p>
  <b>6. Повернення та обмін Товару</b>
</p>
<p>
6.1. Продовольчі товари, доступні на Сайті для Замовлення, не підлягають обміну та поверненню відповідно до Постанови КМУ N172 від 19.03.1994 «Про реалізацію окремих положень Закону України «Про захист прав споживачів» зі змінами та доповненнями.<br>
</p>

<p>
  <b>7. Конфіденційність та персональні дані</b>
</p>
<p>
7.1. Продавець збирає та обробляє персональну інформацію, яку Покупець надає самостійно під час реєстрації або оформлення Замовлення відповідно до Закону України від 01 червня 2010 № 2297-VI «Про захист персональних даних» та Договору.<br>
7.2. Персональні дані збираються і обробляються з метою надання Покупцям доступу до Сайту і обробки Замовлень Покупців, інформування (у тому числі рекламними матеріалами), а також інших дій, пов’язаних з такими цілями.<br>
7.3. Політика конфіденційності та персональних даних за Договором застосовується винятково до Сайту. При переході Покупця на сайти третіх осіб (в тому числі сторонніх сервісів) Покупець керується політикою конфіденційності відповідного сервісу.<br>
7.4. Покупець вказує прізвище та ім’я, номер телефону, адресу доставки замовлення. Решта інформації надається Покупцем за його вибором в коментарі до Замовлення. Покупець самостійно перевіряє достовірність наданої інформації.<br>
7.5. Продавець має право на відправлення рекламних повідомлень, просування Товару, інформаційних матеріалів щодо Товарів, послуг Продавця, заходах та акціях.<br>
7.6. Продавець має право на передачу персональних даних Покупців третім особам, якщо така передача вимагається для виконання Продавцем своїх обов’язків за Договором та захисту прав та свобод Продавця або третіх осіб, якщо Покупець порушує умови Договору.<br>
7.7. Покупець має право відмовитися від отримання рекламної та іншої інформації за допомогою повідомлення на електронну пошту, вказану для контакту на Сайті. Покупець має право запросити інформацію про те, обробляються чи його дані Продавцем. Продавець надає таку відповідь протягом 30 календарних днів.<br>
</p>

<p>
  <b>8. Видалення особистих даних</b>
</p>
<p>
8.1. Користувач може попросити у продавця видалити особисті дані Покупця. Для цього потрібно звернутися на відповідний емейл group.black.group@gmail.com. У запиті потрібно вказати, які дані потрібно видалити та причину видалення цих даних<br>
</p>
      </div>
    </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },

    methods: {
        
    },

    mounted() {
        
    }
}
</script>
